export default {
  setStatusData(state, data) {
    state.statusData = data
  },

  setLoading(state, value) {
    state.loading = value
  },
}

